var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"chart"}},[_c('apexchart',{ref:"chart",staticClass:"chart-wrapper",staticStyle:{"margin-top":"-20px"},attrs:{"type":"treemap","height":'100%',"options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }